import { userService } from 'account/user/service/userService';
import { FormInstance, message } from 'antd';
import { RolePermissionType } from 'permission/role/type/roleType';
import { NavigateFunction } from 'react-router-dom';
import { UserInterface } from '../types/userType';

interface UserEditHandlersProps {
  id: number;
  form: FormInstance;
  navigate: NavigateFunction;
}

interface UserEditHandlersReturn {
  onFinish: () => Promise<void>;
}

export const getUserEditHandlers = ({
  id,
  form,
  navigate,
}: UserEditHandlersProps): UserEditHandlersReturn => {
  const onFinish = async (): Promise<void> => {
    const loadingMessage = message.loading('Updating...', 0);
    try {
      const values = await form.validateFields();
      const user: UserInterface = {
        id: id,
        username: values.username,
        email: values.email,
        first_name: values.first_name,
        last_name: values.last_name,
        platform: values.platform,
        // Switch를 한 번도 건드리지 않으면 undefined다. Boolean으로 좁혀서 "끔"이 항상
        // 명시적으로 전달되게 한다 (필드가 빠지면 BE가 기존 값을 유지해 해제가 안 된다).
        is_lg_channel_vietnam: Boolean(values.is_lg_channel_vietnam),
      };

      if (values.company?.id) {
        user.company = values.company;
      }
      await userService.updateUserWithRole(
        id,
        user,
        values.roles.map((role: RolePermissionType) => role.id)
      );
      loadingMessage();
      navigate('/user', {
        state: {
          message: 'User information has been updated successfully',
          userId: id,
        },
      });
    } catch (error) {
      loadingMessage();
      console.error('Failed to update:', error);
    }
  };

  return {
    onFinish,
  };
};
